class Tabs {

	constructor(node, config = {}) {
		this.index = -1;
		this.node = node;
		this.config = Object.assign( {
			contentsActiveClass: 'tabs__tab--active',
			contentsClass      : 'tabs__tab',
			interactiveClass   : 'tabs--interactive',
			navClass           : 'tabs__nav',
			navItemClass       : 'tabs__nav-item',
			navItemsClass      : 'tabs__nav-items',
			navLinkActiveClass : 'tabs__nav-link--active',
			navLinkClass       : 'tabs__nav-link',
			navNextClass       : 'tabs__nav-next',
			navNextPath        : 'M6 15l5-5-5-5 1-2 7 7-7 7z',
			navPrevClass       : 'tabs__nav-prev',
			navPrevPath        : 'M14 5l-5 5 5 5-1 2-7-7 7-7z',
			navWrapClass       : 'tabs__nav-wrap',
		}, config );

		if ( ! this.node ) {
			return;
		}

		this.tabContents = Array.from(this.node.querySelectorAll(`.${this.config.contentsClass}`)).map((tab) => {
			tab.setAttribute('role', 'tabpanel');
			tab.setAttribute('tabindex', -1);
			tab.hidden = true;
			return tab;
		});

		this.nav = document.createElement('div');
		this.nav.className = this.config.navClass;
		this.nav.innerHTML = `
			<button type="button" class="${this.config.navPrevClass}">
				<svg height="20" width="20" aria-hidden="true" role="img" focusable="false" viewbox="0 0 20 20"><path d="${this.config.navPrevPath}"></svg>
			</button>
			<div class="${this.config.navWrapClass}">
				<ul class="${this.config.navItemsClass}" role="tablist">
					${ this.tabContents.map(( tab, index ) => {
						const title = tab.querySelector('.tabs__title');

						return title ? `
							<li class="${this.config.navItemClass}">
								<a href="#${title.innerText.toLowerCase().replace(/\s+/g, '-')}" class="${this.config.navLinkClass}" data-index="${index}">${title.innerHTML}</a>
							</li>
						`.trim() : '';
					} ).join('') }
				</ul>
			</div>
			<button type="button" class="${this.config.navNextClass}">
				<svg height="20" width="20" aria-hidden="true" role="img" focusable="false" viewbox="0 0 20 20"><path d="${this.config.navNextPath}"></svg>
			</button>
		`.trim();
		this.node.insertBefore(this.nav, this.node.firstChild);

		this.prevArrow = this.nav.querySelector(`.${this.config.navPrevClass}`);
		this.nextArrow = this.nav.querySelector(`.${this.config.navNextClass}`);
		this.navItems  = this.nav.querySelector(`.${this.config.navItemsClass}`);
		this.navLinks  = Array.from(this.nav.querySelectorAll(`.${this.config.navLinkClass}`));

		this.nav.addEventListener('click', (e) => {
			let node = e.target;

			while ( node && node !== this.nav ) {
				if ( node.classList.contains( this.config.navLinkClass ) && node.getAttribute('data-index') ) {
					e.preventDefault();
					this.goTo( parseInt( node.getAttribute('data-index', 10 ) ) );
					break;
				}

				if ( node.classList.contains( this.config.navNextClass ) ) {
					this.next()
					break;
				}

				if ( node.classList.contains( this.config.navPrevClass ) ) {
					this.prev()
					break;
				}

				node = node.parentNode;
			}
		});

		if ( window.location.hash ) {
			for ( let i = 0; i < this.navLinks.length; i++ ) {
				if ( this.navLinks[i].hash === window.location.hash ) {
					this.goTo(i);
					break;
				}
			}
		}

		if ( this.index === -1 ) {
			this.goTo(0);
		}

		this.node.classList.add(this.config.interactiveClass);
	}

	next() {
		if ( this.index < this.navLinks.length - 1 ) {
			this.goTo( this.index + 1 );
			this.scrollItems();
		}
	}

	prev() {
		if ( this.index > 0 ) {
			this.goTo( this.index - 1 );
			this.scrollItems();
		}
	}

	scrollItems() {
		if ( this.navItems.scrollWidth > this.navItems.offsetWidth ) {
			let scrollTo = this.navLinks.reduce( (sum, item, index) => {
				return sum + ( index < this.index ? item.offsetWidth : 0 );
			}, 0 );

			if ( ! Number.isNaN( scrollTo ) ) {
				this.navItems.scrollTo( scrollTo, 0 );
			}
		}
	}

	goTo(index) {
		if ( this.index > -1 ) {
			this.navLinks[this.index].classList.remove(this.config.navLinkActiveClass);
			this.tabContents[this.index].classList.remove(this.config.contentsActiveClass);
			this.tabContents[this.index].setAttribute('tabindex', '-1');
			this.tabContents[this.index].removeAttribute('aria-selected');
			this.tabContents[this.index].hidden = true;
		}

		this.index = index;

		this.navLinks[this.index].classList.add(this.config.navLinkActiveClass);
		this.tabContents[this.index].classList.add(this.config.contentsActiveClass);
		this.tabContents[this.index].setAttribute('aria-selected', 'true');
		this.tabContents[this.index].removeAttribute('tabindex', '-1');
		this.tabContents[this.index].focus();
		this.tabContents[this.index].hidden = false;

		if ( this.index === this.navLinks.length - 1 ) {
			this.nextArrow.setAttribute('disabled', 'disabled');
		} else {
			this.nextArrow.removeAttribute('disabled');
		}

		if ( this.index === 0 ) {
			this.prevArrow.setAttribute('disabled', 'disabled');
		} else {
			this.prevArrow.removeAttribute('disabled');
		}

		// allow flickity to resize itself when inside a tab
		window.dispatchEvent( new CustomEvent('resize') );
	}
}

Tabs.instances = Array.from(document.querySelectorAll('.tabs')).map( n => new Tabs(n));

export default Tabs;
